export default "__VITE_ASSET__ChAnqYDX__"